import { SearchType } from '@/types/most-search-type';
import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';

export { SearchType };

export enum ProgressiveSearchModalKeys {
  SEARCH = 'SEARCH',
  ASK_ADD_MORE_EXAMS = 'ASK_ADD_MORE_EXAMS',
  SELECT_MORE_EXAMS = 'SELECT_MORE_EXAMS',
  ATTENTION_TO_LOSE_LABORATORY_PROCEDURE = 'ATTENTION_TO_LOSE_LABORATORY_PROCEDURE',
  SELECTED_OVERVIEW_EXAMS = 'SELECTED_OVERVIEW_EXAMS',
}

export type RecentSearches = SearchResult & {
  examOrVaccineGroup?: SearchResult[];
};

export type SearchResult = {
  id?: string;
  avatar?: string;
  name?: string;
  code?: string;
  description?: string | null;
  procedureType?: string;
  tussCode?: string;
  displayName?: string;
  subText?: string | null;
  slug?: string | null;
  alias?: string;
  keywords?: string[];
  specialties?: string[];
  availableForTelehealth?: boolean;
  searchType: SearchType;
  source?: string;
  city?: string;
  state?: string;
};

export type SearchHealthResourcesResponse = {
  results: SearchResult[];
  total: number;
};

export type AllSearchResults = {
  [SearchType.ALL]: SearchHealthResourcesResponse;
  [SearchType.PROCEDURE]: SearchHealthResourcesResponse;
  [SearchType.PROFESSIONAL]: SearchHealthResourcesResponse;
  [SearchType.PARTNER]: SearchHealthResourcesResponse;
};

export interface SelectedProcedures {
  id: string;
  code: string;
  displayName: string;
  examOrVaccineGroup?: SelectedProcedures[];
}

export interface SearchModalProps {
  initialSelectedProcedures?: SelectedProcedures[];
  initialKey?: string;
  locationOverride?: OverridedUserLocation;
}
